module.exports = __webpack_public_path__ + "img/dirt-2.55fbce51.png";